import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanEditVehicle = (): boolean => {
  const [canEditVehicle, setCanEditVehicle] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const editAllPermission: Permission = {
    resource: 'vehicles',
    action: 'updatebasic',
    scope: 'all',
  };
  const editProviderPermission: Permission = {
    resource: 'vehicles',
    action: 'updatebasic',
    scope: 'provider',
  };

  const canEditAll = useHasPermission(user, editAllPermission);
  const canEditPermission = useHasPermission(user, editProviderPermission);

  React.useEffect(() => {
    setCanEditVehicle(canEditAll || canEditPermission);
  }, [canEditAll, canEditPermission]);

  return canEditVehicle;
};
